import {apiBaseUrl} from '@fitro/customer-host/api'
import {RichContent} from '@fitro/customer-ui/RichContent'
import type {ComponentProps} from 'react'

export function SanitizedRichContent(props: Omit<ComponentProps<typeof RichContent>, 'assetBaseUrl'>) {
    return <RichContent {...props} assetBaseUrl={apiBaseUrl}/>
}
